'use client';

import PricingSpotlightCard from '@/components/PricingSpotlightCard';

export default function PricingShowcaseHeader({
  config,
  variant = 'page',
  anchorId,
}) {
  const wrapperClass = variant === 'modal'
    ? 'px-5 pt-14 pb-8 sm:px-8 sm:pt-16'
    : 'mb-14';
  const spacingClass = variant === 'modal'
    ? 'mt-10'
    : 'mt-11';
  const titleClass = variant === 'modal'
    ? 'text-3xl sm:text-[2.65rem]'
    : 'text-3xl sm:text-4xl lg:text-[2.85rem]';

  return (
    <div className={wrapperClass}>
      <PricingSpotlightCard
        id={anchorId}
        config={config}
        variant={variant}
      />

      <div className={`text-center ${spacingClass}`}>
        <h1 className={`font-playfair font-bold leading-none text-white ${titleClass}`}>
          {config?.heading}
        </h1>
      </div>
    </div>
  );
}
